module.exports = __webpack_public_path__ + "static/media/favicon.b6797ba8.ico";